import axios from 'axios';
import { toast } from "react-toastify";

export const API_URL2 = process.env.NODE_ENV === 'production' ? `https://letsroll.site/api` : `http://localhost:5000/api`;

const $api2 = axios.create({
    withCredentials: true,
    baseURL: API_URL2,
});

// SEC #8: teacher token lives only in memory — same XSS risk as student token
let _teacherToken: string | null = null;
export const setTeacherToken = (token: string | null) => { _teacherToken = token; };
export const hasTeacherToken = () => !!_teacherToken;

$api2.interceptors.request.use((config) => {
    if (_teacherToken) {
        config.headers.Authorization = `Bearer ${_teacherToken}`;
    }
    return config;
});

export const handleUnauthorized = async () => {
    // Try to delete token from database
    try {
        const token = sessionStorage.getItem('tokenteacher');
        if (token) {
            await axios.post(`${API_URL2}/v1/teacher/logout`, {}, {
                headers: { Authorization: `Bearer ${token}` },
                withCredentials: true
            });
        }
    } catch (e) {
        // Ignore errors from logout call
        console.log('Teacher logout cleanup completed');
    }

    // Clear all auth data
    setTeacherToken(null); // SEC #8: clear in-memory token
    sessionStorage.removeItem('teacher');
    sessionStorage.removeItem('isAuthTeacher');
    sessionStorage.clear();

    // Redirect to teacher login
    setTimeout(() => {
        window.location.href = '/instructorLogIn';
    }, 3000);
};

$api2.interceptors.response.use((config) => {
    return config;
}, async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._isRetry) {
        originalRequest._isRetry = true;
        try {
            const response = await axios.get(`${API_URL2}/v1/teacher/refresh`, { withCredentials: true });
            setTeacherToken(response.data.accessToken); // SEC #8: store in memory only
            return $api2.request(originalRequest);
        } catch (e) {
            handleUnauthorized();
            toast.info('Du har blivit utloggad pga. lång inaktivitet, vänligen logga in igen.')
        }
    }
    throw error;
});

export default $api2;
